import { render } from "./ComparisonMaintenanceReport.vue?vue&type=template&id=4f27b228"
import script from "./ComparisonMaintenanceReport.vue?vue&type=script&lang=js"
export * from "./ComparisonMaintenanceReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtnGroup,QBtn,QTooltip});
